import { FuzzySearchResult } from '@tomtom-international/web-sdk-services';

import { GenericPrediction } from 'components/autocomplete-address-input/types';

export const genericPredictionMapper = ({ id, address }: FuzzySearchResult): GenericPrediction => ({
  place_id: id || '',
  description: address?.freeformAddress || '',
  structured_formatting: {
    main_text: address?.streetName || '',
    secondary_text: address?.freeformAddress || '',
  },
});
